<template>
  <div>
    <div class="dropbox">
      <input type="file" multiple accept="image/*" class="input-file" @change="filesChange($event.target.files)" />
      <p>
        Drag your file(s) here to begin<br/>
        or click to browse
      </p>
    </div>
    <div class="error" v-if="tooLarge">
      Image file was too large
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuctionFileUploadWidget',
    data() {
      return {
        tooLarge: false
      }
    },
    methods: {
      filesChange(fileList) {
        this.tooLarge = false
        if (!fileList.length) return

        Array.from(Array(fileList.length).keys()).map(x => {
          const f = fileList[x]

          const reader = new FileReader()
          reader.addEventListener('load', () => {
            const dataUrl = reader.result
            console.log('AuctionFileUploadWidget: uploaded [%s][%s][%s][%s]:', f.name, f.type, f.size, dataUrl.length)
            if (dataUrl.length > 1024*1024*9) { // 9MB limit for image data (API Gateway has 10MB payload hard limit)
              this.tooLarge = true
            } else {
              this.$emit('uploaded', {name: f.name, type: f.type, size: f.size, dataUrl})
            }
          }, false)
          reader.readAsDataURL(f)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../../pfx.scss';

  .dropbox {
    margin-top: 1rem;
    outline: 2px dashed #ccc;
    outline-offset: -1rem;
    background: #f3f3f3;
    height: 10rem;
    position: relative;
    cursor: pointer;
    z-index: 1;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 10rem;
    position: absolute;
    cursor: pointer;
    z-index: 2;
  }

  .dropbox:hover {
    background: #f0f0f0;
  }

  .dropbox p {
    text-align: center;
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    color: #666;
  }

  .error {
    padding: 1rem;
    background-color: $color-error-text;
    color: white;
    font-weight: 600;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/AuctionFileUploadWidget.vue